import StackTrace from "stacktrace-js";
import Server from "../server";
import Alerts from "./alerts";

export function errorHandler(ex: any) {

    try {
        StackTrace.fromError(ex)
            .then((stack) => {

                let msg = ex.message;
                for (const line of stack) {
                    msg = msg + "\n  " + line.toString()
                }

                console.log("------------------------");
                console.log(msg);
                console.log("------------------------");

                const id = Server.instance().qa(msg);

                Alerts.alert({
                    message: "An internal error has occurred. \nBug tracking id " + id
                });
            });

    } catch (oops) {
        console.log("StackTrace.fromError failed...");
        console.log(oops);
    }

}

export function showStack(msg: string) {

    try {
        const stack_ = StackTrace.get();

        stack_.then((stack) => {

            console.log("------------------------");
            console.log("STACK: " + msg);
            for (const line of stack) {
                console.log(line);
            }
            console.log("------------------------");

        });

    } catch (oops) {
        console.log("StackTrace.fromError failed...");
        console.log(oops);
    }

}
